<script setup lang="ts">
  import {
    slideoverSkeletonContainerClass,
    slideoverContentClass,
    slideoverHeaderSlotClass,
    slideoverFooterSlotClass,
  } from './SlideoverSkeleton.css';
</script>

<template>
  <div :class="slideoverSkeletonContainerClass">
    <div v-if="$slots.header" :class="slideoverHeaderSlotClass">
      <slot name="header" />
    </div>
    <div :class="slideoverContentClass"><slot /></div>
    <div v-if="$slots.footer" :class="slideoverFooterSlotClass">
      <slot name="footer" />
    </div>
  </div>
</template>
